export default __webpack_public_path__ + "static/agency-banking-solutions-digipay-guru-7144922a4494f03709d2dfabf27fa53c.png";